<div class="left" style="height: 20px">
  <svg-icon style="height: 20px" [svgStyle]="{'width.px': 18, 'height.px': 20}" src="/assets/icons/head-and-shoulders-grey.svg"></svg-icon>
</div>
<ng-container i18n>
  Guests
</ng-container>
<div class="toggle" (click)="decrement()">
  <svg-icon style="height: 18px" [svgStyle]="{'width.px': 18, 'height.px': 18}" src="/assets/icons/minus-grey.svg"></svg-icon>
</div>
<span class="value">{{value}}</span>
<div class="toggle" (click)="increment()">
  <svg-icon style="height: 18px" [svgStyle]="{'width.px': 18, 'height.px': 18}" src="/assets/icons/plus-grey.svg"></svg-icon>
</div>
